import './OopsCard.css';
import { useId } from 'preact/hooks';
import { Card } from '../../components/Card';
import { t } from '../../copy/strings';

/**
 * "Esta parte da tela teve um problema…" (§12.8): `<section class="card oops-card" role="status">` com um parágrafo
 * Geist 400 `--fs-body`, `--color-fg-3` (variante `oops` do Card), no lugar do painel que falhou, sem mudar a grade.
 * `role="status"` é uma das regiões implícitas permitidas por AC-15.3-01. Cores forçadas: a borda de `.card` vira
 * `CanvasText` (base.css).
 */
export function OopsCard() {
  const id = useId();
  return (
    <Card variant="oops" class="oops-card" role="status" data-testid="oops-card" labelledBy={id}>
      <p id={id} class="oops-card__text">
        {t('error.oops')}
      </p>
    </Card>
  );
}
